<div [@expandCollapse]="animationState()" class="truelearn-logo-section d-flex justify-content-center">
    <a class="navbar-brand" [routerLink]="['/']" routerLinkActive="active" ariaCurrentWhenActive="page">
        @if (isApex()) {
            @if (expanded()) {
                <img
                    id="apex_logo"
                    src="/assets/common/White-Logo-APEX-full.svg"
                    class="ms-3"
                    alt="APEX"
                    height="50px"
                />
            } @else {
                <img id="apex_logo_small" src="/assets/common/White-Logo-APEX-triangle.svg" alt="APEX" height="32px" />
            }
        } @else if (isComquest()) {
            @if (expanded()) {
                <img
                    id="comquest_logo"
                    src="https://content.truelearn.net/img/Comquest_White.svg"
                    class="ms-3"
                    alt="Comquest"
                    height="35px"
                />
            } @else {
                <img
                    id="comquest_logo_small"
                    src="https://content.truelearn.net/img/Comquest_White_Small.png"
                    alt="Comquest"
                    width="36px"
                    height="32px"
                />
            }
        } @else if (isMedality()) {
            @if (expanded()) {
                <img
                    id="medality_logo"
                    src="https://d2lci6o0v9zqdl.cloudfront.net/img/Medality_White.svg"
                    class="ms-3"
                    alt="Medality"
                    height="40px"
                />
            } @else {
                <img
                    id="medality_logo_small"
                    src="https://d2lci6o0v9zqdl.cloudfront.net/img/Medality_White_Small.svg"
                    alt="Medality"
                    width="36px"
                    height="32px"
                />
            }
        } @else {
            <img id="truelearn_logo" src="assets/tl-logo.png" alt="True Learn" height="32px" />
        }
    </a>
</div>
